import React from "react";
import styled from "styled-components";

interface ComponentProps {
  progressPercent: number;
  progressColorClass: string;
}

type StyledProps = {
  progressPercent: number;
};

//note: using the attrs method together with a style object for this frequently changed style
const ProgressBar = styled.div.attrs<StyledProps>((p) => ({
  style: {
    width: `${p.progressPercent}%`,
  },
}))<StyledProps>`
  height: 100%;
  transition: width 500ms;
`;

const ProgressBarDeterminate = ({
  progressPercent,
  progressColorClass,
}: ComponentProps) => {
  return (
    <ProgressBar
      progressPercent={progressPercent}
      className={progressColorClass}
    />
  );
};

export default ProgressBarDeterminate;
